import emailjs from "@emailjs/browser";

// Both forms (the full one on /contact and the short one on the homepage) send
// through here. Delivered by EmailJS straight from the browser; there is no
// backend. The sender address and the subject line live in the EmailJS template
// (template_shltn4a), not here, and the parameter names below are what that
// template reads - do not rename them without telling Viktor, whose morning
// brief parses these emails.
const SERVICE_ID = "service_brttwa9";
const TEMPLATE_ID = "template_shltn4a";
const PUBLIC_KEY = "1_jzerThzEvdUox_y"; // public by design

/**
 * @param {object} p
 * @param {string} p.name
 * @param {string} p.email
 * @param {string} p.message
 * @param {string} [p.company]
 * @param {string} [p.phone]
 * @param {string} [p.projectType]
 * @param {string} [p.budget]
 */
export const sendEnquiry = ({ name, email, message, company, phone, projectType, budget }) =>
  emailjs.send(
    SERVICE_ID,
    TEMPLATE_ID,
    {
      from_name: name.trim(),
      reply_to: email.trim(),
      company: company?.trim() || "N/A",
      phone: phone?.trim() || "N/A",
      project_type: projectType || "General",
      budget: budget || "N/A",
      message: message.trim(),
      to_email: "hello@malilabs.com",
    },
    PUBLIC_KEY,
  );

/** Count a custom event in Umami, if it is loaded. Never throws. */
export const trackEvent = (name, data) => {
  try {
    window.umami?.track(name, data);
  } catch {
    /* analytics blocked or not loaded */
  }
};
